export default __webpack_public_path__ + "static/media/topBread.ea36c88c.png";